module.exports = __webpack_public_path__ + "img/project_settings.e1cb06ca.png";